var resources = require('itemsViewStrings');
    var strings = resources['_z0tsLb60cgbrpdtFj4xlug'];
export { strings };
export default strings;
